import React from "react";
import { AlertTriangle } from "lucide-react";
import { Badge } from "./ui/badge";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "./ui/tooltip";

const SIZE_CLASSES = {
  sm: "px-1.5 py-0 text-[10px] gap-1",
  md: "px-2 py-0.5 text-xs gap-1.5",
};

export const StaleIndicator = ({ stale, size = "sm", ...props }) => {
  if (!stale) return null;

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Badge
            variant="outline"
            className={`border-amber-400/40 bg-amber-500/10 text-amber-200 ${SIZE_CLASSES[size] || SIZE_CLASSES.sm}`}
            {...props}
          >
            <AlertTriangle className={size === "md" ? "h-3.5 w-3.5" : "h-3 w-3"} />
            Stale
          </Badge>
        </TooltipTrigger>
        <TooltipContent
          className="border border-amber-400/30 bg-[var(--surface-card)] text-amber-100"
          data-testid={props["data-testid"] ? `${props["data-testid"]}-tooltip` : undefined}
        >
          Context may be outdated — re-forge to refresh
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};